<template>
    <div>
        <Form
            :model="searchItem"
            :label-width="85"
            label-position="left"
            :disabled="loading"
            ref="formValidate" 
            :show-message="false"
            style="margin-top:20px"
        >
            <Row >
                <Col span="8">
                    <FormItem label="公告名称">
                        <Input v-model="searchItem.subject" clearable/>
                    </FormItem>
                </Col>
                <Col span="1">
                    <Button type="primary" style="margin-left:20px" @click="getData()">查询</Button>
                </Col>
            </Row>
        </Form>
         <Divider dashed />
        <List>
            <ListItem v-for="(item,index) in noticeList" :key="index">
                <ListItemMeta :avatar="require('../../assets/headerMessage.png')" :description="item.editor" >
                    <template slot="title">
                        <a v-html="item.subject" @click="goNoticePage(item)"></a>
                    </template>
                </ListItemMeta>
                <template slot="extra">
                    <div style="margin-right:20px">{{date.dateVal(item.updated_date, "YYYY/MM/DD")}}</div>
                </template>
            </ListItem>
           
        </List>
        <Page :total="this.totalNum" style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:10px" @on-change="pageChange" />
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            spinShow:false,
            date: new DateUtil(),
            loading:false,
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            searchItem:{
                subject:""
            },
            noticeList:[]
        }
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            this.spinShow=true
            axios.post('/announcement/selAnnouncementInfo', {subject:this.searchItem.subject, ...this.pageInfo}).then(res => { 
                this.spinShow=false
                if (res != null && res.data.length > 0) {
                    var noticeListOrg = JSON.parse(JSON.stringify(res.data))
                    this.totalNum=Number(res.pageInfo.total)
                    this.noticeList = noticeListOrg.filter((item,index)=>{
                        let d = new Date(item.end_time)
                        return item
                    })
                }
            })
       
        },
        goNoticePage(item){
            this.$router.push({ 
                path: '/96D9F7FFBA3ECC423C7C703D2880C8FE723C91EC71D46066/A3FFBEBFDB713E27', 
                query: { id: item.id }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
    }
}
</script>

<style lang="scss" scoped>
    /deep/.ivu-list-item-meta {
        align-items: center;
        .ivu-list-item-meta-title {
            display: inline-block;
        }
        h1,h2,h3,h4,p,span,a{
            font-size: 14px;
            font-weight: bold;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/index/NoticeAnnouncement.vue